import { call, put, takeLatest } from 'redux-saga/effects';
import uniqid from 'uniqid';
import { VERIFY_GOOGLE } from './constants';
import { verifyGoogle } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { GOOGLE_VERIFY } from 'common/strings';
import routeTemplates from 'common/route-templates';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveGoogleCode({ payload, metadata }) {
  const token = readToken();
  const { history } = metadata;

  try {
    yield call(request, {
      method: 'post',
      endpoint: 'app/oidc/google',
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });
    triggerNotification({
      title: GOOGLE_VERIFY.ALERTS.INTEGRATE_GOOGLE_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyGoogle.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyGoogle.error(errorMessage));
  }
  history.push(routeTemplates.project.projectSettings.meeting);
}

export default function* googleVerify() {
  yield takeLatest(VERIFY_GOOGLE.START, saveGoogleCode);
}
